interface SummarySectionProps {
  introText: string?;
  items: { title: string; desc: string }[];
}

export default function SummarySection({ introText, items }: SummarySectionProps) {
  return (
    <div id="summary" className="pt-6">
      <div className="flex items-end gap-2 mb-4">
        <h2 className="text-lg md:text-xl font-bold text-[#121B35]">플래너의 추천 Point</h2>
        <span className="text-[10px] md:text-xs text-[#B9965B] tracking-[0.15em] mb-0.5">
          {/* Verified Reasons */}
        </span>
      </div>
      <div className="bg-white rounded-2xl p-4 ptlg:p-5">
        {introText && introText !== '' && (
          <p className='text-sm md:text-base pb-4 text-[#536079] leading-relaxed'>
            {introText.split('\n').reduce((acc, item) => {
              acc.push(item)
              acc.push(<br />)
              return acc
            }, [])}
          </p>

        )}
        <div className="lg:grid lg:grid-cols-2 lg:gap-x-6 lg:gap-y-4">
          {items?.map((p, i) => (
            <div key={i} className="flex gap-3 py-2">
              <div className="w-1 h-1 rounded-full bg-[#B9965B] mt-2 shrink-0" />
              <div>
                <h3 className="text-sm md:text-base font-semibold text-[#121B35]">{p.title}</h3>
                <p className="text-xs md:text-sm text-[#536079] mt-1 leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}